import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';
import { FacetChangeEvent, FacetItem } from '@hpfc/fc-frontend-core';

@Component({
  tag: 'fccd-icon-detail',
  styleUrl: 'icon-detail.scss',
})
export class IconDetail {
  @Prop() elementId: string;
  @Prop() iconName: string;
  @Prop() headingText: string;
  @Prop() detailText: string;
  @Prop() actionText?: string;

  @Event() fccdIconDetailClicked: EventEmitter<FacetChangeEvent>;

  private handleClick() {
    const facet: FacetItem = new FacetItem(this.elementId, this.elementId);
    this.fccdIconDetailClicked.emit(new FacetChangeEvent(null, facet));
  }

  render() {
    return (
      <div class="flex-container">
        <div class="icon-padding">
          <hp5-icon name={this.iconName} size="lg" />
        </div>
        <div class="use-block">
          <div>
            <hp5-heading size-selection="sm" tag-selection="h2">
              {this.headingText}
            </hp5-heading>
          </div>
          <div>
            <hp5-text-decorator size="sm">{this.detailText}</hp5-text-decorator>
          </div>
          {this.actionText && (
            <hp5-button-decorator type="tertiary" size="sm">
              <button type="button" onClick={() => this.handleClick()}>
                {this.actionText}
              </button>
            </hp5-button-decorator>
          )}
        </div>
      </div>
    );
  }
}
